import theme from "config/theme";
import styled, { css, keyframes } from "styled-components";

/**
 * Ellipsis CSS Loading Animation by https://loading.io/css/
 */

const growIn = keyframes`
    from {
        transform: scale(0);
    }
    to {
        transform: scale(1);
    }
`
const moveRight = distance => keyframes`
    from {
        transform: translate(0, 0);
    }
    to {
        transform: translate(${distance}rem, 0);
    }
`
const shrinkAway = keyframes`
    from {
        transform: scale(1);
    }
    to {
        transform: scale(0);
    }
`

const Container = styled.div`
    ${({iconSize}) => css`
        
        & .lds-ellipsis {
            display: inline-block;
            position: relative;
            width:  ${iconSize*4 + iconSize}rem;
            height:  ${iconSize*2 + iconSize}rem;
        }
        & .lds-ellipsis div {
            position: absolute;
            top: ${(iconSize*2)/2}rem;
            width: ${iconSize}rem;
            height: ${iconSize}rem;
            border-radius: 50%;
            background: ${theme.colors.primary};
            animation-timing-function: cubic-bezier(0, 1, 1, 0);
        }
        & .lds-ellipsis div:nth-child(1) {
            left: 0;
            animation: ${growIn} 0.6s infinite;
        }
        & .lds-ellipsis div:nth-child(2) {
            left: 0;
            animation: ${moveRight(iconSize*2)} 0.6s infinite;
        }
        & .lds-ellipsis div:nth-child(3) {
            left: ${iconSize*2}rem;
            animation: ${moveRight(iconSize*2)} 0.6s infinite;
        }
        & .lds-ellipsis div:nth-child(4) {
            left: ${iconSize*4}rem;
            animation: ${shrinkAway} 0.6s infinite;
        }
    `}
    
`

const Loading = ({iconSize=1}) => {
    return (
        <Container {...{iconSize}}>
            <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </Container>
    )
}

export default Loading;